import { Component } from '@angular/core';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';

@Component({
  selector: 'privacy-text',
  // templateUrl: './privacy.component.html',
  template: `
    <div class="modal" tabindex="-1" id="dialog-privacy">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">ShieldSafe Privacy Policy</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <div class="container pb-110px">
                    <div [innerHTML]="agilityContentModelPrivacy"></div>
                  </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
  `,
  styleUrl: './privacy.component.scss',
  standalone: true
})
export class PrivacyComponent {

  constructor(
    private readonly directSessionLogic: DirectSessionLogicService
  ) {
    
  }

  get agilityContentModelPrivacy(): string {
    return this.directSessionLogic.agilityObjectsSignalValue.privacyBody;
  }
}
